import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as urls from '../utilities/urls';
import { NzTableData } from '../utilities/nz-table.adapter';
import { MerchantTransactionSearch} from './../models/merchant-transactions';
// tslint:disable-next-line: max-line-length
import { TransactionAccountTypes} from '../utilities/common-file';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class ReportService {
    constructor(private httpClient: HttpClient, private router: Router, private authService: AuthService ) {}

// Merchant daily summary report
getDailyMerchantTransactionsWithLimit(tableData: NzTableData<MerchantTransactionSearch, any>) {
    const value = {
      startDate: tableData.search.createdDate.startDate ? tableData.search.createdDate.startDate : '',
      endDate: tableData.search.createdDate.endDate ? tableData.search.createdDate.endDate : '',
      accountTypeIn: tableData.search.accountType ? tableData.search.accountType :
      [TransactionAccountTypes.qrPayment, TransactionAccountTypes.externalPayment, TransactionAccountTypes.refund],
      merchantId: tableData.search.merchantId ? tableData.search.merchantId : '',
      locationId: tableData.search.locationId ? tableData.search.locationId : '',
      appCode: tableData.search.appCode,
      pageSize: tableData.pageSize,
      pageIndex: tableData.pageIndex
  };
    return this.httpClient.post(urls.MerchantSettlementUrls.dailySummary, value);
  }
  // Download Daily summary report as excel
  downloadMerchantDailySummaryReport(value) {
    return this.httpClient.post(urls.MerchantSettlementUrls.dailySummary, value);
  }

}
